export default __webpack_public_path__ + "static/media/gauge-white.2fe0eb9f.svg";